import { useMemo } from "react";
import { verifyElementCondition } from "../../../utils/elements-condition";
import { useFormLogic } from "../context/FormLogicContext";
export var useChoicesConditions = function (element) {
    var _a = useFormLogic(), formValues = _a.formValues, elementsTypeInfoByName = _a.elementsTypeInfoByName;
    var choicesVisible = useMemo(function () {
        return !element.choicesVisibleIf ||
            verifyElementCondition(element.choicesVisibleIf, formValues, elementsTypeInfoByName);
    }, [element.choicesVisibleIf, formValues, elementsTypeInfoByName]);
    var choicesEnabled = useMemo(function () {
        return !element.choicesEnableIf ||
            verifyElementCondition(element.choicesEnableIf, formValues, elementsTypeInfoByName);
    }, [element.choicesEnableIf, formValues, elementsTypeInfoByName]);
    return { choicesVisible: choicesVisible, choicesEnabled: choicesEnabled };
};
